import { AfterViewInit, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from "@angular/core";
import {
  CfsTemplateBaseComponent,
  CfsTemplateError,
  CfsTemplateMediaConfig,
  CFSTemplatePreviewType,
  defaultCfsTemplateMediaConfig,
  getContentDurationByTemplate,
  getFullDisplayTimeByTemplate,
  Template,
  TemplateAnimationType
} from "clearline-common";
import { CommonModule } from "@angular/common";
import { CfsTemplatePreviewComponent } from "./cfs-template-preview";

@Component({
  selector: "lib-cfs-template",
  templateUrl: "./cfs-template.component.html",
  styleUrls: ["./cfs-template.component.scss"],
  standalone: true,
  imports: [CommonModule, CfsTemplatePreviewComponent]
})
export class CfsTemplateComponent implements CfsTemplateBaseComponent, AfterViewInit, OnChanges {
  @Input() template: Template | null = null;
  @Input() animationType: TemplateAnimationType = TemplateAnimationType.Animated;
  @Input() responsive = true;
  @Input() forPrint = false;
  @Input() isLowResolutionScreen = false;
  @Input() isTestMode = false;

  @Input() set mediaConfig(config: CfsTemplateMediaConfig) {
    this.fullMediaConfig = { ...config, fullscreen: !this.isTestMode, coverParent: this.isTestMode };
  }

  @Output() print = new EventEmitter();
  @Output() templateClick = new EventEmitter();
  @Output() ready = new EventEmitter();
  @Output() error = new EventEmitter<CfsTemplateError>();

  @ViewChild(CfsTemplatePreviewComponent) previewTemplateComponent?: CfsTemplatePreviewComponent;

  fullMediaConfig: CfsTemplateMediaConfig = { ...defaultCfsTemplateMediaConfig, fullscreen: true };
  title = "";
  displayTime = 0;
  contentDuration = 0;

  private playPending = false;

  get templateType(): CFSTemplatePreviewType | null {
    if (this.previewTemplateComponent) {
      return this.previewTemplateComponent.templatePreviewType;
    }

    return null;
  }

  get isReady(): boolean {
    return this.previewTemplateComponent ? this.previewTemplateComponent.isReady : false;
  }

  get hasError(): boolean {
    return !!this.previewTemplateComponent?.hasError;
  }

  ngAfterViewInit(): void {
    if (this.playPending && this.previewTemplateComponent) {
      this.playPending = false;

      this.play();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["template"] && this.template) {
      this.displayTime = getFullDisplayTimeByTemplate(this.template);
      this.contentDuration = getContentDurationByTemplate(this.template);
    }
  }

  onTemplateClick() {
    this.templateClick.emit();
  }

  play(): void {
    if (this.previewTemplateComponent) {
      this.previewTemplateComponent.play();
    } else {
      this.playPending = true;
    }
  }

  stop(): void {
    if (this.previewTemplateComponent) {
      this.previewTemplateComponent.stop();
    }
  }

  pause(): void {
    if (this.previewTemplateComponent) {
      this.previewTemplateComponent.pause();
    }
  }

  restart(): void {
    if (this.previewTemplateComponent) {
      this.previewTemplateComponent.restart();
    }
  }
}
